<template>
    <nav class="header-tabs header-nav pb-0 mb-3">
        <ul class="nav">
            <li class="nav-item" v-for="(tab, idx) in content" :key="idx">
                <template v-if="tab.hash">
                    <a
                        v-if="!tab.hidden"
                        v-tooltip="{
                            content: tab.disabled
                                ? 'Funkcjonalność będzie dostępna w kolejnych wersjach aplikacji.'
                                : null
                        }"
                        class="nav-link"
                        :class="{ active: activeTabIndex === idx }"
                        :style="{ opacity: tab.disabled ? '0.6' : '' }"
                        @click.prevent="!tab.disabled && changeTab(tab.disabled, idx, tab.hash)"
                        href="#"
                    >
                        <a-icon v-if="tab.icon" :icon="tab.icon" />

                        <span class="d-flex">
                            <span v-text="tab.text" />
                            <span
                                v-if="
                                    tab.counter !== undefined &&
                                        tab.counter !== null
                                "
                                v-text="tab.counter"
                                class="header-nav__counter"
                                :class="{ active: activeTabIndex === idx }"
                            />
                        </span>
                    </a>
                </template>
                <template v-else>
                    <router-link
                        class="nav-link"
                        :to="tab.route"
                        :class="{ disabled: tab.disabled }"
                        @click.native="handleClick(tab, idx)"
                    >
                        <a-icon v-if="tab.icon" :icon="tab.icon" />

                        <span class="d-flex">
                            <span class="d-none d-md-inline-block" v-text="tab.text" />
                            <span class="d-md-none" v-text="tab.textShort || tab.text" />

                            <ui-spinner-grow
                                v-if="tab.counter === null"
                                :small="true"
                                class="header-nav__counter"
                            />
                            <span
                                v-else-if="tab.counter !== undefined"
                                v-text="tab.counter"
                                class="header-nav__counter"
                                :class="{ active: activeTabIndex === idx }"
                            />
                        </span>
                    </router-link>
                </template>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'HeaderTabs',
    props: {
        content: {
            type: Array
        },
        activeTab: {
            type: Number,
            default: 0
        }
    },
    watch: {
        activeTab: {
            immediate: true,
            handler(index) {
                this.activeTabIndex = index
            }
        }
    },
    created() {
        if (this.$route.hash) {
            const findTab = this.content.findIndex(
                el => el.hash === this.$route.hash
            )
            if (findTab) this.activeTabIndex = findTab

            if (findTab !== this.activeTab) {
                this.$emit('changeTab', findTab)
            }
        }
    },
    data() {
        return {
            activeTabIndex: 0
        }
    },
    methods: {
        changeTab(disabled, idx, hash) {
            if (!disabled) {
                this.$emit('changeTab', idx)
            }
            if (hash && this.$route.hash !== hash) {
                this.$router.push(this.$route.path + hash)
            }
        },

        handleClick(tab, idx, event) {
            !tab.disabled && this.changeTab(tab.disabled, idx)
        }
    }
}
</script>

<style lang="scss">
.nav-link.disabled {
    color: #858b92;
}

.header-tabs {

    .nav {
        // -ms-overflow-style: none;  /* IE and Edge */
        // scrollbar-width: none;  /* Firefox */

        /* Hide scrollbar for Chrome, Safari and Opera */
        ::-webkit-scrollbar {
            // display: none;
        }
    }
}
</style>
